import ServiceRequestAssignForm from 'src/pages/ServiceRequest/ServiceRequestAssignForm';
import Overlay from 'src/components/Overlay';
import Popup from './Popup';
import ServiceRequestScheduling from 'src/pages/ServiceRequest/ServiceRequestScheduling';
import ServiceRequestEditForm from 'src/components/ServiceRequestForm/ServiceRequestEditForm';
import { useServiceRequestDataFromContext } from 'src/pages/ServiceRequest/Context/ServiceRequestContext';

interface ServiceRequestOverlaysProps {
  state: {
    showOverlay: boolean;
    statusOverlay: boolean;
    statusScheduleOverlay: boolean;
    showPopup: boolean;
  };
  setState: (state: any) => void;
  refreshData: () => void;
  handleSaveScheduledAppointment: (
    formData: any,
    serviceRequestId: string
  ) => void;
  handleStatusAssign: (statusFormData: any, serviceRequestId: string) => void;
  onSubmitPopup: (type: string, data: any) => void;
}

const ServiceRequestOverlays = ({
  state,
  setState,
  refreshData,
  handleSaveScheduledAppointment,
  handleStatusAssign,
  onSubmitPopup,
}: ServiceRequestOverlaysProps) => {
  const { showOverlay, statusOverlay, statusScheduleOverlay, showPopup } =
    state;
  const { serviceRequest } = useServiceRequestDataFromContext();

  return (
    <>
      <Overlay
        showOverlay={showOverlay}
        content={
          <ServiceRequestEditForm
            serviceRequest={serviceRequest}
            onClose={() => {
              setState({ ...state, showOverlay: false });
              setTimeout(() => {
                refreshData();
              }, 300);
            }}
            handleSaveScheduledAppointment={(
              formData: any,
              serviceRequestId: any
            ) => handleSaveScheduledAppointment(formData, serviceRequestId)}
            handleStatusChange={handleStatusAssign}
          />
        }
      />
      <Overlay
        showOverlay={statusOverlay}
        content={
          <ServiceRequestAssignForm
            serviceRequest={serviceRequest}
            onClose={() => setState({ ...state, statusOverlay: false })}
            handleStatusChange={handleStatusAssign}
            isLegacyTable={false}
            from={undefined}
          />
        }
      />
      <Overlay
        showOverlay={statusScheduleOverlay}
        content={
          <ServiceRequestScheduling
            serviceRequest={serviceRequest}
            onClose={() => setState({ ...state, statusScheduleOverlay: false })}
            onEventScheduled={(data: any) =>
              handleSaveScheduledAppointment(data, serviceRequest.id)
            }
          />
        }
      />
      {showPopup && <Popup onSubmitPopup={onSubmitPopup} />}
    </>
  );
};

export default ServiceRequestOverlays;
